<template>
  <div>

    <v-layout justify-center>
      <v-flex xs12 sm10 md8 lg6 xl4>

<!-- Header Items -->
        <v-layout>
          <v-flex>
            <v-btn
              @click="$router.push({name: 'Learn'})"
              color="grey"
              large
              text
              >
              < Home
            </v-btn>
          </v-flex>
          <v-flex
            v-if="quizCards"
            class="my-1 mx-5 text-right"
            >
            <div class="ma-2" style="display:inline-block;">
              <span class="red--text text--darken-2">{{quizCards.length}} <span class="overline">New</span></span>
              <span class="grey--text"> - </span>
              <span class="blue--text text--darken-2">{{unknownCards.length}} <span class="overline">Missed</span></span>
              <span class="grey--text"> - </span>
              <span class="green--text text--darken-2">{{knownCards.length}} <span class="overline">Known</span></span>
            </div>

          </v-flex>
        </v-layout>

<!-- Pre-Quiz Items -->
        <div id="initialSelection" v-if="initialSetup">
          <v-card class="pa-5" flat outlined>
            <p class="title red--text text--darken-4">Image Quiz</p>
            <p>How many images would you like to review?</p>
            <v-select
              v-model="numberOfImages"
              :items="numberOfItems"
              background="red"
              color="red darken-4"
              label="Number of Images"
              >
            </v-select>
            <v-btn
              @click="loadQuiz()"
              color="red darken-4"
              dark
              >
              Start Quiz
            </v-btn>
          </v-card>
        </div>

<!-- Quiz Items -->
        <div id="quiz" v-if="quizCards && !complete">

          <v-progress-linear
            :value="cardProgressBar"
            color="red darken-4"
            height="10"
            >
          </v-progress-linear>
          <v-card>
            <v-layout>
              <v-flex></v-flex>

            </v-layout>
          </v-card>

          <v-card class="pa-5" flat outlined>
            <p class="blue--text text--darken-1">Describe what is shown below.</p>
            <img
              :src="currentCard.image"
              @click="showAnswer =! showAnswer"
              class="hover main-image"

              />

            <div id="pre-answer-text" v-if="!showAnswer" class="grey--text text--darken-2">
              <span class="grey--text text--darken-2">Click or tap the image to see the answer.</span>
              <div>
                <v-btn v-if="answerHistory.length > 0" class="my-2"  text color="grey" @click="undoLastAction()"><v-icon>mdi-undo</v-icon>Return to Previous Question</v-btn>
              </div>

            </div>

            <div id="answer" v-if="showAnswer" >
              <span class="grey--text text--darken-2">Did you know the answer?</span>
              <div id="action-buttons">
                <v-btn
                  class="my-2"
                  @click="seeCardAgain()"
                  color="blue darken-3"
                  dark
                  large
                  >
                  <v-icon class="mr-1">
                    mdi-thumb-down
                  </v-icon>
                  No
                </v-btn>
                <v-btn
                  class="ma-2"
                  @click="knowCard()"
                  color="green darken-3"
                  dark
                  large
                  >
                  <v-icon class="mr-1">
                    mdi-thumb-up
                  </v-icon>
                  Yes
                </v-btn>
              </div>

              <v-card id="answer-description"
                class="pa-3"
                outlined
                flat
                >
                <p class="title red--text text--darken-4">{{currentCard.term}}</p>
                <p>{{currentCard.description}}</p>
                <div v-for="(item, index) in currentCard.atlas" >
                    <a :href="item" target="_blank"><img src="/img/atlas.jpg"/></a>
                </div>
                <br v-if="currentCard.other_image.length > 0" />
                <span v-if="currentCard.other_image.length > 0">Additional Examples</span>
                <v-layout wrap>
                  <v-flex xs12 md6 v-for="(y, j) in currentCard.other_image" :key="j">

                      <img class="other-images" :src="y"/>

                  </v-flex>
                </v-layout>
              </v-card>
            </div>
          </v-card>
        </div>

<!-- Post Quiz Items -->
        <div id="post-quiz" v-if="complete">
          <v-card  class="pa-5" flat outlined>
            <p class="title red--text text--darken-4">Quiz complete</p>
            <p>Be sure to review the questions below before starting over.</p>
            <v-btn color="red darken-3" dark class="mr-3 mb-5" @click="goAgain()">Review More Images</v-btn>
            <v-btn color="blue darken-3" dark class="mr-3 mb-5" @click="$router.push({name: 'Learn'})">Return Home</v-btn>
          </v-card>
          <v-card class="px-5 py-2">

            <p class="title mt-5 grey--text text--darken-2">Review Quiz Questions</p>
            <v-card flat outlined class="pa-5" v-for="(card, i) in knownCardContent" :key="i">


              <img
                :src="card.image"
                class="hover main-image"
                />
                <v-card class="pa-3" flat>
                  <p class="title red--text text--darken-4">{{card.term}}</p>
                  <p>{{card.description}}</p>
                  <div v-for="(item, index) in card.atlas" >
                      <a :href="item" target="_blank"><img src="http://hematologyoutlines.com/images/small_rbc.jpg"/></a>
                  </div>
                </v-card>
            </v-card>
          </v-card>
        </div>


      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import _ from 'underscore'
import ImagePlaceholder from '@/components/ImagePlaceholder'
export default {
  name: 'quizImages',
  components: {
    ImagePlaceholder
  },
  data() {
    return {
      allCards: null,
      quizCards: null,
      unknownCards: [],
      knownCards: [],
      numberOfImages: null,
      showAnswer: false,
      initialSetup: true,
      complete: false,
      answerHistory: [],
      numberOfItems: ["5","10","25", "All (" + this.$store.state.images.length + " remaining)"] //added all with count in mounted function
    }
  },


  computed: {
    cardProgressValue() {
      return (this.knownCards.length).toString() +  " / " + (this.quizCards.length + this.knownCards.length).toString()
    },
    cardProgressBar() {
      return this.knownCards.length / (this.quizCards.length + this.knownCards.length + this.unknownCards.length) * 100
    },
    currentCard() {
      if (this.quizCards) {
        let item
        if (this.quizCards.length > 0) {
          item = this.$store.state.imageDict[this.quizCards[0]]
          item.id = this.quizCards[0]
          return item
        }
        else if (this.unknownCards.length > 0) {
          item = this.$store.state.imageDict[this.unknownCards[0]]
          item.id = this.unknownCards[0]
          return item
        }
        else {
          this.$store.dispatch('removeCompletedImages')
          this.complete = true
          this.quizCards = null
          this.$iosHandlers ? this.saveDataToIOS() : this.saveDataToCookie()
          return null
        }
      }
    },
    knownCardContent() {

      let content = []
      this.knownCards.forEach(card => {
        content.push(this.$store.state.imageDict[card])
      })
      return content
    }
  },
  methods: {
    loadQuiz() {
      this.knownCards = []
      this.answerHistory = []

      this.$store.dispatch('serveImages', this.numberOfImages)
      this.quizCards = this.$store.state.quizImages
      this.allCards = this.$store.state.images

      this.showAnswer = false
      this.initialSetup = false
      this.complete = false
    },
    goAgain(){
      this.initialSetup = true
      this.complete = false
      this.showAnswer = false
      this.answerHistory = []
    },
    knowCard(){
      if (this.quizCards.length > 0) {
        this.answerHistory.push({to:'known', from:'new', id: this.currentCard.id})
        this.knownCards.push(this.quizCards.shift())

      }
      else {
        this.answerHistory.push({to:'known', from:'unknown', id: this.currentCard.id})
        this.knownCards.push(this.unknownCards.shift())

      }


      this.showAnswer = false
      //reset window position
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    seeCardAgain(){

      if (this.quizCards.length > 0) {
        this.answerHistory.push({to:'unknown', from:'new', id: this.currentCard.id})
        this.unknownCards.push(this.quizCards.shift())

      }
      else {
        this.answerHistory.push({to:'unknown', from:'unknown', id: this.currentCard.id})
        this.unknownCards.push(this.unknownCards.shift())

      }
      this.showAnswer = false
      //reset window position
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    undoLastAction() {
      let lastAction = this.answerHistory[this.answerHistory.length - 1] //get last action
      if (lastAction.to == 'known' && lastAction.from == 'new') {
        this.quizCards.unshift(this.knownCards.pop())
      }
      else if (lastAction.to == 'known' && lastAction.from == 'unknown') {
        this.unknownCards.unshift(this.knownCards.pop())
      }
      else if (lastAction.to == 'unknown' && lastAction.from == 'unknown') {
        this.unknownCards.unshift(this.unknownCards.pop())
      }
      else if (lastAction.to == 'unknown' && lastAction.from == 'new') {
        this.quizCards.unshift(this.unknownCards.pop())
      }

      this.answerHistory.pop() // remove entry
    },
    completedDeck(){
      this.complete = true
    },
    saveDataToIOS() {
      let progress = JSON.stringify({
        termsOfService: this.$store.state.termsOfService,
        images: this.$store.state.images,
        terms: this.$store.state.terms,
      })
      this.$iosHandlers.saveData.postMessage(progress);
    },
    saveDataToCookie() {
      let progress = JSON.stringify({
        termsOfService: this.$store.state.termsOfService,
        images: this.$store.state.images,
        terms: this.$store.state.terms,
      })
      this.$store.dispatch("setCookie", progress)

    }
  }
}
</script>

<style>
.hover {
  cursor: pointer;
}
.main-image {
  width: 100%;
}
.other-images {
  width: 100%;
}
</style>
